module.exports = __webpack_public_path__ + "static/media/suitability-score-icon.156a5c1e.svg";